import React, { useState } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Typography,
  Stack,
  Button,
} from "@mui/material";
import dayjs from "dayjs";

const presets = [
  { label: "This Month", value: "this_month" },
  { label: "Last Month", value: "last_month" },
  { label: "Last 7 Days", value: "last_7_days" },
  { label: "This Year", value: "this_year" },
  { label: "Custom", value: "custom" },
];

const getRangeFromPreset = (preset) => {
  const today = dayjs();

  switch (preset) {
    case "this_month":
      return {
        startDate: today.startOf("month").format("YYYY-MM-DD"),
        endDate: today.endOf("month").format("YYYY-MM-DD"),
      };
    case "last_month":
      return {
        startDate: today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD"),
        endDate: today.subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
      };
    case "last_7_days":
      return {
        startDate: today.subtract(6, "day").format("YYYY-MM-DD"),
        endDate: today.format("YYYY-MM-DD"),
      };
    case "this_year":
      return {
        startDate: today.startOf("year").format("YYYY-MM-DD"),
        endDate: today.endOf("year").format("YYYY-MM-DD"),
      };
    default:
      return { startDate: "", endDate: "" };
  }
};

const DateRangePicker = ({ onChange }) => {
  const [selectedPreset, setSelectedPreset] = useState("this_month");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");

  const handlePresetChange = (e) => {
    const preset = e.target.value;
    setSelectedPreset(preset);

    if (preset !== "custom") {
      const range = getRangeFromPreset(preset);
      setCustomStart("");
      setCustomEnd("");
      onChange(range);
    }
  };

  const handleApplyCustom = () => {
    if (customStart && customEnd) {
      onChange({ startDate: customStart, endDate: customEnd });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography fontWeight="bold" mb={1}>
        Date Range
      </Typography>

      <TextField
        select
        label="Preset"
        value={selectedPreset}
        onChange={handlePresetChange}
        fullWidth
        size="small"
        sx={{ mb: 2 }}>
        {presets.map((p) => (
          <MenuItem key={p.value} value={p.value}>
            {p.label}
          </MenuItem>
        ))}
      </TextField>

      {selectedPreset === "custom" && (
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
          <TextField
            label="Start Date"
            type="date"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={customStart}
            onChange={(e) => setCustomStart(e.target.value)}
          />
          <TextField
            label="End Date"
            type="date"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={customEnd}
            onChange={(e) => setCustomEnd(e.target.value)}
          />
          <Button
            variant="contained"
            onClick={handleApplyCustom}
            disabled={!customStart || !customEnd}>
            Apply
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default DateRangePicker;
